const initialState = {};
export default function (state = initialState, action) {
  const newState = Object.assign({}, state);

  if (action.meta && action.meta.requestStatuses) {
    const keys = Object.keys(action.meta.requestStatuses);
    keys.forEach(key => {
      newState[key] = action.meta.requestStatuses[key];
    });
  }

  return newState;
}